import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Cookies from "js-cookie";
import Swal from 'sweetalert2';
import storage from "../../../Storage";
import {encode} from "../../../Helper";
import socket from "../../../Socket";
import C from "../../../Constant";
import styled from 'styled-components';


const StyledImg = styled.img`
  height: 18px;
  width: 18px;
  filter: invert(48%) sepia(6%) saturate(426%) hue-rotate(167deg) brightness(94%) contrast(87%);
`;

class Logout extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    ask(){
        Swal.fire({
            title: 'Signing Out',
            text: "Are you sure you want to log out? Check our great promotions and bonuses before you leave!",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#d33',
            confirmButtonColor: '#83F57D',
            confirmButtonText: 'Sign out',
            reverseButtons: true,
        }).then((result) => {
            if (result.value)
            {
                socket.emit(C.LOGOUT_USER);
                localStorage.clear();
                Cookies.remove("session");
                Cookies.remove("auth");
                Cookies.remove("uid");
                window.location.replace('./');
            }
        });
    }

    render(){
        return(<div>
                <a className='logout-icons' style={{display:"flex",alignItems:"center",gap:"10px"}} onClick={this.ask} >
                    {/* <i className="dripicons-exit text-muted ml-1 mr-2 text-drop"/> */}
                    <StyledImg className=''  src='/assets/images/nanoicons/logout.png'/>
                    <span style={{ fontSize:'clamp(10px, 3vw, 16px)', color: '#B9C4C7',lineHeight:"27px",fontWeight:"700"}}>Logout</span>
                </a>
        </div>);
    }
}

export default withRouter(Logout);
